import {
  ToggleButton as CXToggleButton,
  ToggleButtonGroup as CXToggleButtonGroup
} from '@sanlamcx/react-ui-next-toggle-button';

export const ToggleButton = CXToggleButton;
export const ToggleButtonGroup = CXToggleButtonGroup;
